import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import NotFound from "../common/NotFound";
import Stats from "../stats/Stats";
import Students from "../students/Students";
import Results from "../results/Results";
import FacultiesResult from "../results/FacultiesResult";
import ClassResult from "../results/ClassesResult";
import StudentsResults from "../results/StudentsResult";
import FinanceRevenues from "../finance/Revenues";
import FinanceClassList from "../finance/_classes/ClassLists";
import FinanceStudentsList from "../finance/_students/Students";
import StudentProfile from "../student-profile/Profile";
import FinanceExpenses from "../finance/Expenses";
import FacultiesSalary from "../finance/_facultiesSalaries/FacultiesSalary";
import TeacherProfile from "../teacher-profile/Profile";
import SectionSalary from "../finance/_sections/SectionsSalary";
import StaffProfile from "../staff-profile/Profile";
import Creditors from "../finance/_creditors/Creditors";
import CreditorProfile from "../creditor-profile/Profile";
import ContractorProfile from "../contractor-profile/Profile";
import ExpenseSubAccounts from "../finance/_expenseSubAccounts/ExpenseSubAccounts";
import SubAccountsExpenses from "../finance/_subAccountsExpenses/SubAccountsExpenses";
import Contractors from "../finance/_contractors/Contractors";
import FinanceDashboard from "../finance/_dashboard/Dashboard";
import ExpenseBudgetList from "../finance/_expenseBudgets/BudgetLists";
import ExpenseBudgetAccountsList from "../finance/_expenseBudgets/_budgetAccounts/AccountsLists";
import Classes from "../classes/Classes";
import ClassStuents from "../classes/_students/Students";
import Subjects from "../subjects/Subjects";
import IncomesSubAccounts from "../finance/_incomesSubAccounts/IncomesSubAccounts";
import SubAccountsRevenues from "../finance/_subAccountsRevenues/SubAccountsRevenues";
import DiscountsList from "../finance/_discounts/DiscountsLists";
import TypeList from "../finance/_discounts/_types/TypeList";
import RevenueBudgets from "../finance/_revenueBudgets/BudgetLists";
import RevenueBudgetAccountsList from "../finance/_revenueBudgets/_budgetAccounts/AccountsLists";
import PastBalances from "../finance/_teacherPastBalance/PastBalances";
import PastBalancesByFaculties from "../finance/_facultiesPastBalance/PastBalances";
import Benefits from "../finance/_teacherBenefits/Benefits";
import BenefitFaculties from "../finance/_teacherBenefits/_benefitFaculties/BenefitFaculties";
import BenefitTeachers from "../finance/_teacherBenefits/_benefitTeachers/BenefitTeachers";
import Staff from "../staff/Staff";
import Teachers from "../teachers/Teachers";
import MyAccountProfile from "../account/MyAccountProfile";
import Books from "../library/Books";
import BorrowedBooks from "../library/BorrowedBooks";
import Monographs from "../library/Monographs";
import Timetable from "../timetable/Timetable";
import StudentRoster from "../timetable/StudentRoster";
import AttendanceAdmin from "../attendance/AttendanceAdmin";
import AbsenceWarnings from "../attendance/AbsenceWarnings";
import Applicants from "../applicants/Applicants";
import ApplicantDetail from "../applicants/ApplicantDetail";

class Routes extends Component {
  state = {
    basePath: "/mis",
  };

  render = () => {
    const { basePath } = this.state;

    return (
      <Switch>
        <Route
          path={`${basePath}/revenueBudgets/accounts/:aid`}
          render={(p) => <RevenueBudgetAccountsList {...p} />}
        />
        <Route
          path={`${basePath}/revenueBudgets`}
          render={(p) => <RevenueBudgets {...p} />}
        />
        <Route
          path={`${basePath}/discounts/types/:tid`}
          render={(p) => <TypeList {...p} />}
        />
        <Route
          path={`${basePath}/discounts`}
          render={(p) => <DiscountsList {...p} />}
        />
        <Route
          path={`${basePath}/revenues/types/:tid/accounts/:aid/subAccounts/:sid/revenues`}
          render={(p) => <SubAccountsRevenues {...p} />}
        />
        <Route
          path={`${basePath}/revenues/types/:tid/accounts/:aid`}
          render={(p) => <IncomesSubAccounts {...p} />}
        />
        <Route
          path={`${basePath}/classes/:cid/students`}
          render={(p) => <ClassStuents {...p} />}
        />
        <Route
          path={`${basePath}/subjects`}
          render={(p) => <Subjects {...p} />}
        />
        <Route path={`${basePath}/books/borrowed`} render={() => <BorrowedBooks />} />
        <Route path={`${basePath}/books`} render={() => <Books />} />
        <Route path={`${basePath}/monographs`} render={() => <Monographs />} />
        <Route
          path={`${basePath}/attendance/warnings`}
          render={() => <Redirect to={`${basePath}/results/warnings`} />}
        />
        <Route path={`${basePath}/attendance`} render={() => <AttendanceAdmin />} />
        <Route path={`${basePath}/results/warnings`} render={() => <AbsenceWarnings />} />
        <Route
          path={`${basePath}/timetable/:lectureId/roster/:date`}
          render={(p) => <StudentRoster {...p} />}
        />
        <Route path={`${basePath}/timetable`} render={() => <Timetable />} />
        <Route
          path={`${basePath}/applicants/:id`}
          render={() => <ApplicantDetail />}
        />
        <Route path={`${basePath}/applicants`} render={() => <Applicants />} />
        <Route
          path={`${basePath}/classes`}
          render={(p) => <Classes {...p} />}
        />
        <Route
          path={`${basePath}/expenseBudgets/accounts/:aid`}
          render={(p) => <ExpenseBudgetAccountsList {...p} />}
        />
        <Route
          path={`${basePath}/expenseBudgets`}
          render={(p) => <ExpenseBudgetList {...p} />}
        />
        <Route
          path={`${basePath}/finance/dashboard/:path`}
          render={(p) => <FinanceDashboard {...p} />}
        />
        <Route
          path={`${basePath}/contractor/:cid/profile/:path`}
          render={(p) => <ContractorProfile {...p} />}
        />
        <Route
          path={`${basePath}/facultiesPastBalance`}
          render={(p) => <PastBalancesByFaculties {...p} />}
        />
        <Route
          path={`${basePath}/teacherBenefits/:benefit/faculties/:faculty`}
          render={(p) => <BenefitTeachers {...p} />}
        />
        <Route
          path={`${basePath}/teacherBenefits/:benefit/faculties`}
          render={(p) => <BenefitFaculties {...p} />}
        />
        <Route
          path={`${basePath}/teacherBenefits`}
          render={(p) => <Benefits {...p} />}
        />

        <Route
          path={`${basePath}/teachersBalances/:fid`}
          render={(p) => <PastBalances {...p} />}
        />
        <Route
          path={`${basePath}/contractors`}
          render={(p) => <Contractors {...p} />}
        />
        <Route
          path={`${basePath}/expenses/types/:tid/accounts/:aid/subAccounts/:sid/expenses`}
          render={(p) => <SubAccountsExpenses {...p} />}
        />
        <Route
          path={`${basePath}/expenses/types/:tid/accounts/:aid`}
          render={(p) => <ExpenseSubAccounts {...p} />}
        />
        <Route
          path={`${basePath}/creditor/:cid/profile/:path`}
          render={(p) => <CreditorProfile {...p} />}
        />
        <Route
          path={`${basePath}/expenses/debtType/:did/creditors`}
          render={(p) => <Creditors {...p} />}
        />
        <Route
          path={`${basePath}/staff/:sid/profile/:path`}
          render={(p) => <StaffProfile {...p} />}
        />
        <Route
          path={`${basePath}/expenses/salary/sections/:sid`}
          render={(p) => <SectionSalary {...p} />}
        />
        <Route
          path={`${basePath}/teachers/:tid/profile/:path`}
          render={(p) => <TeacherProfile {...p} />}
        />
        <Route
          path={`${basePath}/expenses/salary/faculties/:fid`}
          render={(p) => <FacultiesSalary {...p} />}
        />
        <Route
          path={`${basePath}/expenses/:tid`}
          render={(p) => <FinanceExpenses {...p} />}
        />
        <Route
          path={`${basePath}/students/:sid/profile/:path`}
          render={(p) => <StudentProfile {...p} />}
        />
        <Route
          path={`${basePath}/students/fees/faculties/:fid/classes/:cid`}
          render={(p) => <FinanceStudentsList {...p} />}
        />
        <Route
          path={`${basePath}/students/fees/faculties/:fid/classes`}
          render={(p) => <FinanceClassList {...p} />}
        />
        <Route
          path={`${basePath}/revenues/:tid?`}
          render={(p) => <FinanceRevenues {...p} />}
        />
        <Route
          path={`${basePath}/results/classes/:cid/:sid`}
          render={(p) => <StudentsResults {...p} />}
        />
        <Route
          path={`${basePath}/results/:fid/:cid`}
          render={(p) => <ClassResult {...p} />}
        />
        <Route
          path={`${basePath}/results/:fid`}
          render={(p) => <FacultiesResult {...p} />}
        />
        <Route path={`${basePath}/teachers`} render={() => <Teachers />} />
        <Route path={`${basePath}/results`} render={() => <Results />} />
        <Route path={`${basePath}/students`} render={() => <Students />} />
        <Route path={`${basePath}/staff`} render={() => <Staff />} />
        <Route path={`${basePath}/stats`} render={() => <Stats />} />
        <Route
          path={`${basePath}/my-profile`}
          render={() => <MyAccountProfile />}
        />
        <Route render={() => <NotFound />} />
      </Switch>
    );
  };
}

export default Routes;
